var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('z-icon',{class:[
        'z-icon-block',
        ("z-icon-block--size-" + _vm.size)
    ],attrs:{"name":_vm.name}})}
var staticRenderFns = []

export { render, staticRenderFns }